export default function ({ app, store, $gtm }) {
  // Function to initialize GTM when data is available
  const initializeGTM = () => {
    const networkData = store.state['booking-networks']?.getBookingNetworksRequest?.data;
    if (networkData?.google_tag_manager_id) {
      $gtm.init(networkData.google_tag_manager_id);
      initializeConsent();
      
      return true;
    }
    return false;
  };

  const initializeConsent = () => {
    const session = app.$session;
    if (session && session.get('cookie_accepted')) {
      const preferences = session.get('cookie_preferences') || {
        technical: true,
        analytics: false,
        profiling: false
      };
      
      const consentState = {
        'ad_storage': preferences.technical ? 'granted' : 'denied',
        'ad_user_data': preferences.analytics ? 'granted' : 'denied',
        'ad_personalization': preferences.profiling ? 'granted' : 'denied',
        'analytics_storage': preferences.analytics ? 'granted' : 'denied'
      };
      
      $gtm.push({
        event: 'consent',
        consent_state: consentState
      });
    }
  };

  if (!initializeGTM()) {
    store.watch(
      (state) => state['booking-networks']?.getBookingNetworksRequest?.data,
      (data) => {
        if (data?.google_tag_manager_id) {
          initializeGTM();
        }
      },
      { deep: true }
    );
  }
} 